import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MODALS, SVG_ICONS } from '../../constants';
import SVGComponent from '../SVG/SVGComponent';

const ErrorModal = (props) => {
  const navigate = useNavigate();

  const closeModal = () => {
    props.setOpenModal({ modal: '' });
    if (props.modal === MODALS.SESSION_EXPIRED) {
      props.logout({
        callApi: false,
        navigate,
      });
    }
  };

  return (
    <div className="modal modal--open">
      <div className="dialog p-0">
        <div className="dialog__info text-center">
          <SVGComponent
            className="dialog__info-icon"
            src={`${SVG_ICONS.homeIcons}#error-sign`}
          />
          <h2>Error!</h2>
          <p>
            {props.message}
            <br />
            {props.additionalMessage || 'Please try again'}
          </p>
        </div>
        <div className="dialog__info-btn" onClick={closeModal}>Dismiss</div>
      </div>
    </div>
  );
};

export default ErrorModal;